import script from "./bangzhushuoming.vue?vue&type=script&setup=true&lang=js"
export * from "./bangzhushuoming.vue?vue&type=script&setup=true&lang=js"

import "./bangzhushuoming.vue?vue&type=style&index=0&id=3c5f6fc5&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c5f6fc5"]])

export default __exports__